import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../Firebase/AuthProvider";
import { db } from "../firebase";
import { getData } from "../Firebase/firestoreGet";
import { useNavigate } from "react-router-dom";
import { decodeObj } from "../Functions";
import './measurements.css';

const measure_profile = {
    "u":[ 
    {"value":"length","name":"Length"},
    {"value":"chest_around","name":"Chest"},
    {"value":"stomach","name":"Stomach"},
    {"value":"hip","name":"Hip"},
    {"value":"shoulder_width","name":"Shoulder"},
    {"value":"sleeve_length","name":"Sleev Length"},
    {"value":"neck","name":"Neck"},
    {"value":"bisep","name":"Bisep"}],
    "l":[
        {"value":"leg_length","name":"Leg Length"},
        {"value":"waist","name":"Waist"},
        {"value":"bottom","name":"Bottom"},
        {"value":"hip","name":"Hip"},
        {"value":"thigh","name":"Thighs"},
        {"value":"circle","name":"Circle"}
    ],
}

function SavedM({setSelM, sel_m, cat, info}) {
    const [loading, setLoading] = useState(true)
    const { user } = useContext(AuthContext);

    const [svd, setSvd] = useState()

    const [isMobile, setIsMobile] = useState(false)

    const [expand, setExpand] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 950); // Adjust the width based on CSS
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(()=>{
        if(user){
            let usrid = user.email
            if(!usrid){
                usrid = user.phoneNumber
            }

            const collection = db.collection('Users').doc('measurements').collection(usrid)
            getData(collection).then((data)=>{
                const final = []
                data.forEach((ele)=>{
                    if(checkValid(ele)){
                        final.push(ele)
                    }
                })
                setSvd( final )
                if(final.length > 0){
                    setSelM( {...final[0], ...{key:0}} )
                }
                setLoading(false);
            })
        } else {
            navigate( "/login" , {state:{from:`measurement/saved/${info}`}})
        }
    }, [user])

    const checkValid = (obj)=>{
        if(cat === 1){
            return Object.hasOwn( obj, "lower_body" )
        } else if(cat === 2){
            return (Object.hasOwn( obj, "lower_body" ) && Object.hasOwn( obj, "upper_body" ))
        } else {
            return Object.hasOwn(obj,  "upper_body" )
        }
    }

    const addToCart = ()=>{
        let data = decodeObj(info)
        data["measurements"] = sel_m

        if( Object.hasOwn(data, "id") ){
            let local = JSON.parse( localStorage.getItem("sel"))
            local.forEach((k, i)=>{
                if(k["id"] === data["id"]){
                    local[i] = data
                }
            })
            localStorage.setItem("sel", JSON.stringify(local))
        }else{
            let currC = localStorage.getItem("sel")
            if(currC && JSON.parse(currC).length > 0){
                let upC = JSON.parse(currC)
                let c = upC[upC.length - 1]["id"] + 1
                data["id"] = c
                upC.push(data)
                localStorage.setItem("sel", JSON.stringify(upC))
            }else{
                data["id"] = 1
                localStorage.setItem("sel", JSON.stringify([data]))
            }
        }    
        navigate('/cart');
    }

    if(loading) return <div>Loading...</div>;

    return (  
    <>
    { user &&
    <div className="saved-m-page">
        {/* Header Section */}
        <header className="page-header-section">
            <div className="inner-wrap">
                <h1>Choose From Saved Measurements</h1>
                <p>Select a profile from your previous orders and we will take care of the rest.</p>
            </div>
        </header>

        {svd && svd.length > 0 ? (
        <section className="main-content-section">
            <div className="inner-wrap split-layout">
                
                {/* Left Side: List of Measurements */}
                <div className="left-list-panel">
                    {svd.map((val, key)=>{
                        const isActive = sel_m && val.doc === sel_m.doc;
                        return(
                            <div 
                                key={key}
                                className={`measurement-card ${isActive ? 'active' : ''}`} 
                                onClick={()=>{
                                    setSelM({...val, ...{key:key}}); 
                                }}
                            >
                                <div className="profile-info">
                                    <h3>{key+1}. {val.name}</h3>
                                    <p>Age: {val.age || 'N/A'} | Height: {val.height || 'N/A'}cm</p>
                                </div>
                                <div className="radio-circle"></div>
                            </div>
                        )
                    })}

                    {/* Add New Measurement Button */}
                    <button className="btn-add-new" onClick={() => navigate(`/measurement/custom/${info}`)}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                        Add New Measurement
                    </button>
                </div>

                {/* Right Side: Full Details Panel */}
                {sel_m && (
                <div className="right-details-panel">
                    
                    <div className="details-header">
                        <h2>{sel_m.name} Measurement</h2>
                    </div>

                    {/* Basic Stats */}
                    <div className="basic-stats">
                        {sel_m.age && <div className="stat-item">Age: <strong>{sel_m.age}</strong></div>}
                        {sel_m.height && <div className="stat-item">Height: <strong>{sel_m.height}cm</strong></div>}
                        {sel_m.weight && <div className="stat-item">Weight: <strong>{sel_m.weight}kg</strong></div>}
                    </div>

                    {/* Measurement Grid */}
                    <div className="measurements-grid">
                        
                        {/* Upper Body */}
                        {sel_m.type === 1 && sel_m.upper_body ? (
                        <div className="measure-group">
                            <h4>Upper Body</h4>
                            <ul class="measure-list">
                                {measure_profile.u.map((val, i)=>{
                                    if(sel_m.upper_body[val.value]) {
                                        return <li key={i}>{val.name} <span class="value">{sel_m.upper_body[val.value]} IN</span></li>
                                    }
                                    return null;
                                })}
                            </ul>
                        </div>
                        ) : sel_m.upper_body ? (
                        <div className="measure-group">
                            <h4>Upper Body</h4>
                            <ul class="measure-list">
                                <li>Upper Body <span class="value">{sel_m.upper_body} IN</span></li>
                            </ul>
                        </div>
                        ) : null}

                        {/* Lower Body */}
                        {sel_m.type === 1 && sel_m.lower_body ? (
                        <div className="measure-group">
                            <h4>Lower Body</h4>
                            <ul class="measure-list">
                                {measure_profile.l.map((val, i)=>{
                                    if(sel_m.lower_body[val.value]) {
                                        return <li key={i}>{val.name} <span class="value">{sel_m.lower_body[val.value]} IN</span></li>
                                    }
                                    return null;
                                })}
                            </ul>
                        </div>
                        ) : sel_m.lower_body ? (
                        <div className="measure-group">
                            <h4>Lower Body</h4>
                            <ul class="measure-list">
                                <li>Lower Body <span class="value">{sel_m.lower_body} IN</span></li>
                            </ul>
                        </div>
                        ) : null}

                    </div>

                    {/* Action Buttons (Edit & Continue) */}
                    <div className="action-buttons">
                        <button className="btn-continue" onClick={()=>{ addToCart() }}>Continue</button>
                    </div>

                </div>
                )}

            </div>
        </section>
        ) : (
            <div style={{textAlign: 'center', marginTop: '40px'}}>
                <p style={{fontSize: '1.2rem', marginBottom: '20px'}}>You do not have any saved Measurements</p>
                <button className="btn-continue" onClick={() => navigate(`/measurement/custom/${info}`)}>Add New Measurement</button>
            </div>
        )}

        {/* Fallback / OR Section */}
        <section className="fallback-section">
            <div class="inner-wrap">
                <div class="divider">
                    <span>OR</span>
                </div>
                
                <div class="fallback-options-grid">
                    {/* Size Chart Card */}
                    <div class="fallback-card" onClick={() => navigate(`/measurement/size_chart/${info}`)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"></path>
                        </svg>
                        <h4>By Size Chart</h4>
                        <p>Easily find your ideal fit from our standard sizes.</p>
                    </div>

                    {/* Clone a Cloth Card */}
                    <div class="fallback-card" onClick={() => navigate(`/measurement/clone/${info}`)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 12 20 22 4 22 4 12"></polyline>
                            <rect x="2" y="7" width="20" height="5"></rect>
                            <line x1="12" y1="22" x2="12" y2="7"></line>
                            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                        </svg>
                        <h4>Clone a Cloth</h4>
                        <p>Send us your best fitting cloth to replicate.</p>
                    </div>
                </div>
            </div>
        </section>

    </div> 
    }
    </>
    );   
}

export default SavedM;
